/**************************************************
 * Nombre:       Escuelas_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import fondo from '../../../Recursos/fondos.png'
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";


const Escuelas_Portada = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                >


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 9}}
                        sx={{
                            background: '#ffffff50',
                            backdropFilter: 'blur(5px)',
                            color: "#fff",
                            borderBottom: 6,
                            borderColor: theme.palette.info.main,
                            py: 6,
                            px: 6,
                            mt: 24,
                            mb: 14
                        }}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontFamily: NEGRITA, fontSize: 62, fontWeight: 600}}>¿QUe son las escuelas
                                de aprendizaje?</Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontSize: 24, fontWeight: 600, textAlign: 'center'}}>
                                Son espacios de investigación y proyectos liderados por expertos que integran teoría y
                                práctica. ¡Inscríbete y potencia tu perfil en este ecosistema de
                                innovación!
                            </Typography>
                        </Grid>

                    </Grid>


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Escuelas_Portada

